export default "<p>base works!</p>\n"